//import one from '../assets/svg/projects/one.svg'
//import two from '../assets/svg/projects/two.svg'
//import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
//import five from '../assets/svg/projects/five.svg'
//import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'
//import nine from '../assets/svg/projects/nine.svg'
//import ten from '../assets/svg/projects/ten.svg'
//import eleven from '../assets/svg/projects/eleven.svg'
//import twelve from '../assets/svg/projects/twelve.svg'

export const projectsData = [
    {
        id: 1,
        projectName: 'Green Grocery',
        projectDesc: 'This project is a website where customers can buy vegetables directly from farmers for low rates compared to the market.',
        tags: ['MongoDB','Express','React','Node JS'],
        code: 'https://github.com/mullaguraharish/GreenGrocery',
        demo: 'http://greengrocery30.herokuapp.com/',
        image: 'https://res.cloudinary.com/h2camp/image/upload/v1663490308/samples/GreenGrocery_qoytd2.png'
    },
    {
        id: 2,
        projectName: 'Book Space',
        projectDesc: 'This project aims at making book services available to everyone at low costs on a single click.',
        tags: ['HTML', 'CSS', 'JS','Django'],
        code: 'https://github.com/mullaguraharish/BookSpace',
        demo: 'http://anirudhjak.pythonanywhere.com/',
        image: 'https://res.cloudinary.com/h2camp/image/upload/v1663495313/samples/Bookspace_yxec4i.png'
    },
    {
        id: 3,
        projectName: 'Solar System',
        projectDesc: 'This project is written in OpenGL that will accurately animate the Solar System which can’t be captured by an actual camera precisely.',
        tags: ['OpenGL', 'Computer Graphics','Animation'],
        code: 'https://github.com/mullaguraharish/Solar-System',
        demo: 'https://github.com/mullaguraharish/Solar-System',
        image: 'https://res.cloudinary.com/h2camp/image/upload/v1663496042/samples/SolarSystem_dektlq.png'
    },
    
    {
        id: 4,
        projectName: 'Knowledge Graph Based on Movies',
        projectDesc: 'This project bulits a knowledge graphs based on movies which gives information about singers, writers and movies released. It also gives most recommended movies similar to the given movie.',
        tags: ['Information Retrieval','Knowledge Graph'],
        code: 'https://github.com/mullaguraharish/Knowledge-Graph-Based-On-Movies',
        demo: 'https://github.com/mullaguraharish/Knowledge-Graph-Based-On-Movies',
        image: four
    },
    {
        id: 5,
        projectName: 'Python Games',
        projectDesc: 'Built different games like Black Jack, War, Guess and Tic Tac Toe in Python.',
        tags: ['Python','OOPS'],
        code: 'https://github.com/mullaguraharish/PythonGames',
        demo: 'https://github.com/mullaguraharish/PythonGames',
        image: eight
    },
    {
        id: 6,
        projectName: 'Regression Analysis in R',
        projectDesc: 'This project performs the Regression Analysis in R. It performs simple linear regression analysis, simple non-linear regression analysis and calculating R^2 values.',
        tags: ['R', 'Regression-Analysis','Correlational-Analysis'],
        code: 'https://github.com/mullaguraharish/Regression-Analysis-in-R',
        demo: 'https://github.com/mullaguraharish/Regression-Analysis-in-R',
        image: seven
    },
    {
        id: 7,
        projectName: 'Fashion Store',
        projectDesc: 'This project aims at desigining a Fashion Store to shop all the best cameras, watches and shirts. ',
        tags: ['HTML','CSS','JS'],
        code: 'https://github.com/mullaguraharish/Fashion_store',
        demo: 'https://zealous-coast-0b3ee0810.azurestaticapps.net/',
        image: 'https://res.cloudinary.com/h2camp/image/upload/v1663495825/samples/Fashion_Store_nye64i.png'
    },
    {
        id: 8,
        projectName: 'Slytherin Game',
        projectDesc: 'Built a 2D Snake game using pygame module including many multimedia functionalities like images, audio and video.',
        tags: ['Python', 'Pygame','Multimedia'],
        code: 'https://github.com/mullaguraharish/SlytherinGame',
        demo: 'https://github.com/mullaguraharish/SlytherinGame',
        image: 'https://res.cloudinary.com/h2camp/image/upload/v1663497787/samples/Slytherin_pjhsos.png'
    },
    // {
    //     id: 7,
    //     projectName: 'Uber Lite',
    //     projectDesc: 'Uber clone',
    //     tags: ['Flutter'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: six
    // },
    // {
    //     id: 8,
    //     projectName: 'Stock Market App',
    //     projectDesc: 'A simple stock market API app',
    //     tags: ['React', 'Redux', 'Bootstrap'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: seven
    // },
    
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
